import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Terms() {
  const navigate = useNavigate();
  
  const primaryColor = '#00C6AE';
  const textPrimary = '#111827';
  const textSecondary = '#6B7280';
  const borderColor = '#E5E7EB';

  return (
    <div style={{
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      background: '#FFFFFF',
      color: textPrimary,
      minHeight: '100vh',
      padding: '80px 20px 40px',
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
      }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'transparent',
            border: 'none',
            color: primaryColor,
            cursor: 'pointer',
            fontSize: '16px',
            marginBottom: '32px',
            textDecoration: 'underline',
          }}
        >
          ← Back
        </button>

        <h1 style={{
          fontSize: '42px',
          fontWeight: 700,
          marginBottom: '16px',
          color: textPrimary,
        }}>
          Terms of Service
        </h1>

        <p style={{
          color: textSecondary,
          fontSize: '14px',
          marginBottom: '40px',
        }}>
          Last updated: January 27, 2026
        </p>

        <div style={{
          lineHeight: 1.8,
          color: textPrimary,
        }}>
          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px', color: primaryColor }}>
              1. Acceptance of Terms
            </h2>
            <p style={{ marginBottom: '16px' }}>
              By accessing and using SignalCue ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px', color: primaryColor }}>
              2. Description of Service
            </h2>
            <p style={{ marginBottom: '16px' }}>
              SignalCue is a recruitment intelligence platform that provides data processing, candidate scoring, and relationship mapping services for recruitment agencies. The Service transforms ATS data into actionable insights and prioritized candidate lists.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px', color: primaryColor }}>
              3. User Accounts
            </h2>
            <p style={{ marginBottom: '16px' }}>
              You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px', color: primaryColor }}>
              4. Data and Privacy
            </h2>
            <p style={{ marginBottom: '16px' }}>
              You retain ownership of all data you provide to SignalCue. By using the Service, you grant SignalCue a license to process, store, and analyze your data solely for the purpose of providing the Service. We handle your data in accordance with our Privacy Policy and applicable data protection laws.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px', color: primaryColor }}>
              5. Acceptable Use
            </h2>
            <p style={{ marginBottom: '16px' }}>
              You agree not to use the Service:
            </p>
            <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
              <li>For any unlawful purpose or in violation of any laws</li>
              <li>To transmit any malicious code, viruses, or harmful data</li>
              <li>To attempt to gain unauthorized access to the Service or related systems</li>
              <li>To interfere with or disrupt the Service or servers</li>
              <li>To use automated systems to access the Service without authorization</li>
            </ul>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px', color: primaryColor }}>
              6. Intellectual Property
            </h2>
            <p style={{ marginBottom: '16px' }}>
              The Service, including its original content, features, and functionality, is owned by SignalCue and is protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px', color: primaryColor }}>
              7. Limitation of Liability
            </h2>
            <p style={{ marginBottom: '16px' }}>
              SignalCue shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of the Service.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px', color: primaryColor }}>
              8. Termination
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We may terminate or suspend your account and access to the Service immediately, without prior notice, for any reason, including breach of these Terms. Upon termination, your right to use the Service will cease immediately.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px', color: primaryColor }}>
              9. Changes to Terms
            </h2>
            <p style={{ marginBottom: '16px' }}>
              We reserve the right to modify these Terms at any time. We will notify users of any material changes by posting the new Terms on this page and updating the "Last updated" date. Your continued use of the Service after such modifications constitutes acceptance of the updated Terms.
            </p>
          </section>

          <section style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '16px', color: primaryColor }}>
              10. Contact Information
            </h2>
            <p style={{ marginBottom: '16px' }}>
              If you have any questions about these Terms, please contact us at:
            </p>
            <p style={{ marginBottom: '16px' }}>
              Email: legal@signalcue.ai<br />
              Address: SignalCue, [Your Address]
            </p>
          </section>
        </div>

        <div style={{
          marginTop: '60px',
          paddingTop: '32px',
          borderTop: `1px solid ${borderColor}`,
          textAlign: 'center',
          color: textSecondary,
          fontSize: '14px',
        }}>
          <p>&copy; 2026 SignalCue. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}
